<button mat-icon-button [matMenuTriggerFor]="userMenu" #userMenuTrigger="matMenuTrigger" id="userMenuTrigger">
    <mat-icon>account_circle</mat-icon>
</button>

<mat-menu #userMenu="matMenu" [overlapTrigger]="false" class="toolbar-dropdown-menu user-menu">

    <a mat-menu-item routerLink="/change-password">
        <mat-icon>vpn_key</mat-icon>
        <span>{{'Settings.Personal-Settings.Change-Password' | translate}}</span>
    </a>

    <a mat-menu-item routerLink="/personal-settings" id="PersonalSettingsLink" >
        <mat-icon>sentiment_satisfied_alt</mat-icon>
        <span>{{'Settings.Personal-Settings.Title' | translate}}</span>
    </a>

    <a mat-menu-item routerLink="/personal-availability" id="PersonalAvailability" *ngIf="showPersonalAvailability">
        <mat-icon>timelapse</mat-icon>
        <span>{{'Settings.Employees.Employees.Menu-Personal-Availability' | translate}}</span>
    </a>

</mat-menu>